import React from 'react';
import ReactDOM from 'react-dom';
import SearchAgent from './components/SearchAgent';

export const searchAgent = (elementId, type='wheels') => {
  try {
    ReactDOM.render(<SearchAgent type={type} />, document.getElementById(elementId));
  } catch (e) {
    // Can't initialize search agent
  }
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/search-agent.js
 **/